﻿export function accordion() {
    const accordions = document.getElementsByClassName("accordion");
    for (let accordion of accordions) {
      let accordionTitles = accordion.getElementsByClassName('accordion-title');

      for (let accordionTitle of accordionTitles) {
        accordionTitle.addEventListener("click", function (e) {
          e.preventDefault();
          let parentContainer = accordionTitle.parentNode;
          parentContainer.classList.toggle('is-active');
        });
      }
    }
}
